import * as TYPES from './types';
export default {
    [TYPES.SET_RESULT](payload) {
        this.result = payload || null;
    },
    [TYPES.SET_WAITING](payload) {
        this.waiting = payload;
    },
    [TYPES.SET_PAGE_INDEX](payload) {
        this.pageIndex = payload;
    },
    [TYPES.SET_ACTIVE_COUNT](payload) {
        this.activeCount = payload || null;
    },
    [TYPES.SET_SOLD_COUNT](payload) {
        this.soldCount = payload || null;
    },
    // addLog( payload) {
    //     this.logs.push(payload);
    // }
};
